import type { SeedingCampaignDetail } from './types';

/**
 * 시딩 캠페인 상세 — 화면 상태별 앱바 헤더 타이틀.
 *
 * Figma baseline 기준 (전 상태 헤더 montage 검수, 2026-05-28):
 * - 모집형 신청 화면 (recruiting, 전품절 신청 불가 화면 포함) → "캠페인 신청"
 * - 모집형 신청 완료·진행·결과 (applied, selected~contentRegistered, rejected, closedSelecting) → "{브랜드명} 캠페인"
 * - 제안형 수락 전·품절 (pending/productSelected/soldOut) → "캠페인 모집"
 * - 제안형 수락 완료·배송 진행 (preparing/shipping/delivered/contentRegistered) → "{브랜드명} 캠페인" (SID-4329)
 *
 * NOTE(SID-4278): 신청 완료(applied) 후 내 캠페인 상세 헤더가 "캠페인 신청" 으로 남던 버그 수정 —
 * applied 는 신청 화면이 아니라 신청 완료 상세이므로 "{브랜드명} 캠페인" 이 맞다. "캠페인 신청" 헤더는
 * 신청 전(recruiting) 화면 전용. (recruiting 은 별도 신청 라우트가 자체 하드코딩 타이틀을 쓰며,
 * 통일 상세/신청내역 상세는 participation 이 있어 recruiting 으로 진입하지 않는다.)
 */

/** 모집형에서 "캠페인 신청" 헤더를 쓰는 신청 전(recruiting) 화면 */
const RECRUIT_APPLICATION_STATUSES = new Set<string>(['recruiting']);

/**
 * 제안형에서 "캠페인 모집" 헤더를 쓰는 수락 전·품절 단계.
 * NOTE(SID-4329): preparing(수락 완료=상품 준비중)은 수락 후 상세이므로 "{브랜드명} 캠페인" 이 맞다.
 * 수락 전(pending/productSelected)·품절(soldOut)만 "캠페인 모집".
 */
const PROPOSE_RECRUITING_STATUSES = new Set<string>(['pending', 'productSelected', 'soldOut']);

export const resolveSeedingAppbarTitle = (
  detail: Pick<SeedingCampaignDetail, 'kind' | 'status' | 'brand'>,
): string => {
  const { kind, status, brand } = detail;

  if (kind === 'recruit') {
    if (RECRUIT_APPLICATION_STATUSES.has(status)) return '캠페인 신청';
    return `${brand.name} 캠페인`;
  }

  if (PROPOSE_RECRUITING_STATUSES.has(status)) return '캠페인 모집';
  return `${brand.name} 캠페인`;
};
